import React from "react";
import loading from "../assets/images/loading.png";

const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-6">
      {/* Illustration */}
      <div className="relative flex items-center justify-center mb-4">
        <div className="w-28 h-36 bg-gray-100 rounded-xl flex items-center justify-center">
           <div><img src={loading} style={{height: "8rem"}}/></div>
        </div>
      </div>

      {/* Heading */}
      <div style={{color: "#333843",
      fontFamily: "Inter",
      fontWeight: "600",
      fontSize: "20px"

      }}>Fetching data..</div>

      {/* Description */}
      <p style={{
        color: "#667085",
        fontFamily: "Inter",
        fontWeight: "500",
        fontSize: "14px"
      }}>
       Please wait while we load your information...
      </p>
    </div>
  );
};

export default Loading;

